import httpClient from '../../http';

export async function sendEventRdStation(data: any) {
  return httpClient.post(`/rd/events`, data);
}
